import React from 'react';
import { SingleSelectDropdown } from '@ui-library/select';
import { Select } from 'antd';
import { LabelDiv } from '@ui-library/typography';
import Svg from '@svg/index';
import { useMappingState } from '../tableMappingProvider';
import classes from '../tableMapping.module.scss';
import ErrorLabel from '@ui-library/errorLabel';

const { Option } = Select;
interface SelectUserIdProps {
  overrideRowName: string;
  isValid: boolean;
  columns?: string[];
}

const SelectUserId: React.FC<SelectUserIdProps> = ({
  columns,
  isValid,
  overrideRowName,
}: SelectUserIdProps) => {
  const { loading, overridesConfig, setOverridesConfig, ifUpdate, viewOnly } = useMappingState();

  const all_columns = columns || [];

  const defaultValue = overrideRowName;

  const [value, setValue] = React.useState({
    currentValue: defaultValue,
    prevSubValue: defaultValue,
    currentSubValue: defaultValue,
  });

  const setValues = (values: {
    currentValue?: string;
    prevSubValue?: string;
    currentSubValue?: string;
  }) => {
    setValue({ ...value, ...values });
  };

  const onSubmit = React.useCallback(
    (val: string) => {
      const overrideRow = overrideRowName;
      setValues({ currentValue: val });
      setOverridesConfig({ [overrideRow]: val });
    },
    [value],
  );

  const onChnageUserIdColumn = React.useCallback(
    (v: string) => {
      onSubmit(v);
    },
    [value],
  );
  if (isValid && !loading) {
    const identifierColumn = overridesConfig?.[overrideRowName];
    const isColumnNotFound = Boolean(identifierColumn && !columns?.includes(identifierColumn));
    return (
      <div className={`${classes.identifier__wrapper} select-user-id_container`}>
        <LabelDiv className="m-b-xs">{overrideRowName}</LabelDiv>
        <Svg name="right-arrow" display="none" />
        <div className={classes.identifier__select}>
          <SingleSelectDropdown
            showSearch
            value={identifierColumn}
            onChange={onChnageUserIdColumn}
            allowClear
            disabled={viewOnly || ifUpdate}
            hasError={isColumnNotFound}
          >
            {all_columns.map((opt) => (
              <Option value={opt} key={`single-select-opt-key-${opt}`}>
                {opt}
              </Option>
            ))}
          </SingleSelectDropdown>
          <ErrorLabel error={isColumnNotFound} errorMessage="Column not found" />
        </div>
      </div>
    );
  }
  return null;
};

export default SelectUserId;
